import React, { useContext, useEffect, useState } from 'react';
import './PackagesBottomSheet.css';
import { getAppEnv } from '../../../config/env';
import { Context } from '../../AppContext';

const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

interface PackageInfo {
  title: string;
  sub_title: string;
  package_name: string;
  package_description: Array<{
    icon: string;
    text: string;
  }>;
  city_list: Array<{
    image_url: string;
    name: string;
  }>;
  view_cta_title: string;
  view_cta_sub_title: string;
  close_cta: string;
  redirection_url: string;
}

interface PackagesBottomSheetProps {
  packageData: PackageInfo;
  onClose: () => void;
}

const PackagesBottomSheet: React.FC<PackagesBottomSheetProps> = ({
  packageData,
  onClose
}) => {
  const { trackTemplateEvent } = useContext(Context);
  const descriptionLength = packageData.package_description.length;
  const [currentDescIndex, setCurrentDescIndex] = useState(0);
  useEffect(() => {
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDescIndex(prev => (prev + 1) % descriptionLength);
    }, 1500);

    return () => clearInterval(timer);
  }, [descriptionLength]);

  const handleViewCta = () => {
    if (packageData.redirection_url) {
      window.location.href = packageData.redirection_url;
      trackTemplateEvent(`Cab_SEO_Packages_Mobile_BottomSheet_Clicked`);
    }
  };

  return (
    <div className="packages-overlay" onClick={onClose}>
      <div className="packages-bottom-sheet" onClick={e => e.stopPropagation()}>
        <div className="sheet-content">
          <div className="header">
            <h2>{packageData.title}</h2>
          </div>

          <div className="package-details">
            <p className="sub-title">{packageData.sub_title}</p>
            <h3 className="package-name">{packageData.package_name}</h3>
            <div className="package-description-container">
              <div className="description-wrapper" key={currentDescIndex}>
                <img
                  src={`${PUBLIC_URL}/static/public/sealTick.png`}
                  alt=""
                  className="description-icon"
                />
                <p className="package-description">
                  {packageData.package_description[currentDescIndex].text}
                </p>
              </div>
            </div>
          </div>
          <div className="city-list">
            {packageData.city_list.map((city, index) => (
              <>
                <div key={index} className="city-item">
                  <img
                    src={`${PUBLIC_URL}/static/public/${city.image_url}`}
                    alt={city.name}
                  />
                  <span>{city.name}</span>
                </div>
              </>
            ))}
          </div>

          <div className="cta-container">
            <button className="view-cta" onClick={handleViewCta}>
              <div className="cta-text-container">
                <span className="title-text">{packageData.view_cta_title}</span>
                <span className="subtitle-text">
                  {packageData.view_cta_sub_title}
                </span>
              </div>
            </button>
            <button className="close-cta" onClick={onClose}>
              {packageData.close_cta}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PackagesBottomSheet;
